<template>
  <div>
    <div class="page-header">
      <a-button
        type="link"
        icon="arrow-left"
        class="back-btn"
        @click="goBack"
      />
      <span class="header-divider" />
      <h4 class="page-title">{{ $t("menu.nouvelleDepense") }}</h4>
    </div>
    <div class="card">
      <div class="card-body">
        <depense-create-form
          :lookups="lookups"
          :loading="loadingCreate"
          @submit="onSubmitDepense"
        />
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/axios";
import DepenseCreateForm from "./components/DepenseCreateForm.vue";
import {
  fetchDecaissementLookups,
  createDecaissementDepense,
} from "@/services/api/compV3/decaissement";
import { showApiError } from "@/utilities/showApiError";
import { Modal } from "ant-design-vue";

export default {
  name: "CompV3Decaissement",
  components: {
    DepenseCreateForm,
  },
  data() {
    return {
      lookups: {
        units: [],
        categories: [],
        subcategories: [],
        associates: [],
        providers: [],
        companies: [],
        activities: [],
        classRooms: [],
        employees: [],
        paymentSources: {
          myCaisses: [],
          otherCaisses: [],
          depenseCashCaisses: [],
          caisseBanks: [],
        },
      },
      loadingCreate: false,
    };
  },
  async created() {
    await this.loadLookups();
  },
  methods: {
    goBack() {
      this.$router.push("/decaissement/saisie-paiement");
    },
    async loadLookups() {
      try {
        const [lookupsRes, employeesRes] = await Promise.all([
          fetchDecaissementLookups(),
          apiClient.get("/employees/dropdown-list"),
        ]);
        this.lookups = {
          ...this.lookups,
          ...(lookupsRes.data || {}),
          employees: employeesRes.data || [],
        };
      } catch (e) {
        this.$message.error(this.$t("warning.connectionProblem"));
      }
    },
    async onSubmitDepense(
      { depensePayload, paymentPayload, inverseSchedulesPayload },
      resetForm
    ) {
      this.loadingCreate = true;
      try {
        await createDecaissementDepense({
          ...depensePayload,
          payment: paymentPayload,
          ...(inverseSchedulesPayload
            ? { inverseSchedules: inverseSchedulesPayload }
            : {}),
        });
        if (resetForm) resetForm();
        this.$message.success(this.$t("success.operationEffectue"));
      } catch (e) {
        const data = e && e.response && e.response.data;
        if (data && data.errorCode === "DUPLICATE_PROVIDER_INVOICE_NUMBER") {
          Modal.confirm({
            title: this.$t("decaissement.duplicateInvoiceTitle"),
            content: this.$t("errorCode.DUPLICATE_PROVIDER_INVOICE_NUMBER"),
            icon: "exclamation-circle",
            closable: true,
            maskClosable: true,
            okText: this.$t("decaissement.viewExistingInvoice"),
            cancelText: this.$t("action.fermer"),
            onOk: () => {
              const query = { tab: "invoices" };
              if (depensePayload.beneficiaryId) {
                query.provider = depensePayload.beneficiaryId;
              }
              if (depensePayload.invoiceNumber) {
                query.invoiceNumber = String(depensePayload.invoiceNumber).trim();
              }
              this.$router.push({
                path: "/decaissement/fournisseurs",
                query,
              });
            },
          });
          return;
        }
        showApiError(this, e);
      } finally {
        this.loadingCreate = false;
      }
    },
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  margin-bottom: 16px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  white-space: nowrap;
  overflow: hidden;
}
.back-btn {
  padding: 0 4px;
  font-size: 16px;
  color: #595959;
  flex-shrink: 0;
}
.back-btn:hover {
  color: #1890ff;
}
.header-divider {
  width: 1px;
  height: 22px;
  background: #e8e8e8;
  flex-shrink: 0;
}
.page-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}
</style>
